import React, { useState, useEffect } from 'react'
import { db } from '../firebase'
import { collection, getDocs, getDoc, doc, addDoc, deleteDoc, query, where } from 'firebase/firestore/lite'
import SignonLog from './SignonLog'; // Import the new component

const SignonOff = () => {
    const [name, setName] = useState('')
    const [estimatedReturn, setEstimatedReturn] = useState('')
    const [users, setUsers] = useState([])

    const avatars = [
        'chinaman.jpg',
        'redbass.jpg',
        'blubberlip.jpg',
        'scat.jpg',
        'batfish.jpg',
        'garfish.jpg',
        'silver-drummer.jpg',
        'red-morwong.jpg',
        'groper.jpg',
        'blue-groper.jpg'
    ];

    const fetchUsers = async () => {
        const usersCol = collection(db, 'users')
        const usersSnapshot = await getDocs(usersCol)
        const usersData = usersSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))
        console.log(usersData)
        setUsers(usersData)
    }

    const fetchSignons = async () => {
        const signonsCol = collection(db, 'signons')
        const now = new Date()
        const fourteenDaysAgo = new Date(now - 14 * 24 * 60 * 60 * 1000)
        const signonsQuery = query(signonsCol, where('timestamp', '<', fourteenDaysAgo))
        const signonsSnapshot = await getDocs(signonsQuery)

        for (const signonDoc of signonsSnapshot.docs) {
            await deleteDoc(signonDoc.ref)
        }
    }

    useEffect(() => {
        fetchUsers() // Initial fetch
        fetchSignons() // Clear old signons
    }, [])

    const handleSignOn = async () => {
        if (name.trim() && estimatedReturn.trim()) {
            const avatar = avatars[Math.floor(Math.random() * avatars.length)]; // Select random avatar
            const usersCol = collection(db, 'users')
            const timestamp = new Date().toISOString() // Get current timestamp
            await addDoc(usersCol, { name, action: 'signon', timestamp, estimatedReturn, avatar }); // Add user document
            const signonsCol = collection(db, 'signons');
            await addDoc(signonsCol, { name, action: 'signon', timestamp, estimatedReturn }); // Add signon record
            setName('')
            fetchUsers() // Fetch users after signing on
        }
    }

    const handleSignOff = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to sign off?")
        if (isConfirmed) {
            const userDoc = doc(db, 'users', id)
            const userSnapshot = await getDoc(userDoc)
            const userData = userSnapshot.data()
            await deleteDoc(userDoc) // Delete user document
            const signonsCol = collection(db, 'signons')
            await addDoc(signonsCol, { name: userData.name, action: 'signed off', timestamp: new Date().toISOString() }) // Add signoff record
            fetchUsers() // Fetch users after signing off
        }
    }

    return (
        <div className="container">
            <h1>Sunny Coast Skindivers Sign On/Off</h1>
            <div className="input-container">
                <div className='position-relative'>
                    <label className='label' htmlFor="name">Enter your name:</label>
                    <input
                        id="name"
                        className="input"
                        type="text"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                <div className='position-relative'>
                    <label className='label' htmlFor="estimatedReturn">Estimated time of return (HH:MM):</label>
                    <input
                        id="estimatedReturn"
                        className="input"
                        type="time"
                        placeholder="Estimated time of return (HH:MM)"
                        value={estimatedReturn}
                        onChange={(e) => setEstimatedReturn(e.target.value)}
                    />
                </div>
                <button className="btn" onClick={handleSignOn}>Sign On</button>
            </div>
            <h2>Currently Signed On Users</h2>
            {users.length === 0 ? (
                <p>No users are currently signed on.</p>
            ) : (
                <ul className="user-list">
                    {users.map((user) => (

                        <li key={user.id} className="user-item">
                            <img className='user-avatar' src={process.env.PUBLIC_URL + '/' + user.avatar} alt="Avatar" />
                            {user.name} - Signed on: {new Date(user.timestamp).toLocaleString()}
                            {user.action === 'signon' && ` - Estimated Return: ${user.estimatedReturn}`}
                            <button className="btn-sign-off" onClick={() => handleSignOff(user.id)}>Sign Off</button>
                        </li>
                    ))}
                </ul>
            )}
            <SignonLog /> {/* Include the SignonLog component */}
        </div>
    )
}

export default SignonOff